<template>
  <v-text-field :value="cellId" prefix="$" suffix="" readonly height="24" style="border-color: orangered !important;"></v-text-field>
</template>

<script>
export default {
  name: 'AnswerCell',
  props: {
    cellId: String,
    answerId: String,
    questionId: String,
    question: Object
  }
};
</script>

<style scoped>
.column-header {
  text-align: center;
  font-weight: bold;
}
</style>
